import type { ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;

export const loginApi = {
  /**
   * @description 云测账号密码用户登录
   */
  loginByAccount(data: {
    userName: string;
    password: string;
  }): Promise<{ code: number; expire: number; token: string; passwordWeak?: boolean }> {
    return request({
      method: 'POST',
      url: '/login',
      data,
    });
  },

  /**
   * @description 通过passport utoken 登陆
   */
  loginByPassportToken(data: { utoken: string }): Promise<{ code: number; expire: number; token: string }> {
    return request({
      method: 'POST',
      url: '/loginByPassportToken',
      data,
    });
  },

  /**
   * @description 重置密码 - 获取邮箱验证码
   */
  getEmailCaptcha(data: { type: 'reset'; email: string }): ResponseType {
    return request({
      method: 'POST',
      url: '/captcha',
      data,
    });
  },

  /**
   * @description MFA 邮箱验证码校验，返回一次性 mfaToken
   */
  verifyMfa(data: { email: string; code: string }): Promise<{ code: number; data?: { mfaToken: string } }> {
    return request({
      method: 'POST',
      url: '/api/v1/user/verify-mfa',
      data,
    });
  },

  /**
   * @description 重置密码 - 验证邮箱验证码
   */
  resetPassword(data: { email: string; captcha: string; password: string }): ResponseType {
    return request({
      method: 'POST',
      url: '/resetPassword',
      data,
    });
  },
};
